module.exports = __webpack_public_path__ + "img/rnd1.6a688757.jpg";